import styled from "styled-components";

export const LogoImg = styled.img`
  width: 22px;
  height: 21px;
  margin: 21px 10px;
  margin-left: 0;
`;



// WEBPACK FOOTER //
// ./src/components/Logo/style.js